'use client'

import { Component, ErrorInfo, ReactNode, useEffect } from 'react'
import { trackEvent } from "@/lib/analytics";

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

// Componente que faz o redirecionamento para login com query param de erro
function AuthErrorRedirect() {
  useEffect(() => {
    // Redireciona para a página de login com parâmetro de erro
    window.location.href = '/?auth_error=1'
  }, [])

  return null
}

export class AuthErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      hasError: false
    }
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    trackEvent('app_error', {
      name: error.name,
      message: (error.message || '').slice(0, 200),
    })

    console.error('Auth Error Boundary caught an error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      // Redireciona para login ao invés de mostrar página de erro
      return <AuthErrorRedirect />
    }

    return this.props.children
  }
}

// Wrapper component with i18n
interface AuthErrorBoundaryWrapperProps {
  children: ReactNode
  fallback?: ReactNode
}

export function AuthErrorBoundaryWrapper({ children, fallback }: AuthErrorBoundaryWrapperProps) {
  return (
    <AuthErrorBoundary fallback={fallback}>
      {children}
    </AuthErrorBoundary>
  )
}